import { LogoTransportType } from '@lmn/lmn-components';
import { type JourneyContractSegment, JourneyContractSegmentTransportType } from '@/domainLogic/index.ts';
import type { TransportLogosCompany } from '@lmn/lmn-components/components/Trip/TransportSummary/components/transportLogos/TransportLogosTypes.d.ts';
import type { TranslationFunction } from '../../translations/Translation';

export function getCompanies(t: TranslationFunction, segments: TransportSegment[], separator: string = ', ') {
  const companiesArray = [...new Set(segments.map((segment: TransportSegment) => segment.company.name))];
  return companiesArray.length > 2
    ? t('vacation.select.flightmodal.multiplecompanies')
    : companiesArray.join(separator);
}

export function getCompaniesLogos(segments: TransportSegment[]) {
  return [...new Set(segments.map((segment: TransportSegment) => segment.company.code))];
}

export function getTransportLogosCompany(segments: JourneyContractSegment[]): TransportLogosCompany[] {
  return [
    ...new Set(
      segments.map((segment: JourneyContractSegment) => ({
        code: segment.transport.companyCode,
        type:
          segment.transport.type === JourneyContractSegmentTransportType.TRAIN
            ? LogoTransportType.TRAIN
            : LogoTransportType.FLIGHT,
        name: segment.transport.companyName,
      }))
    ),
  ];
}
